// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
import { selectValue } from "#/admin/legacy/sp-select/index.js";
import { settleMount } from "#ce/framework/mount-ready";

const TRACKED_NUMBER_SELECT_ID = "tracked-number-select";

/** Returns the item picked in the tracked-number sp-select, or null for another control or no pick. */
export function pickedTrackedNumber(control) {
  if (control.id !== TRACKED_NUMBER_SELECT_ID) {
    return null;
  }

  const item = control.items.find((choice) => choice.value === control.value);

  if (!item || !item.value) {
    return null;
  }

  return item;
}

/** Removes `item` from the tracked-number sp-select and clears its value. */
export function dropTrackedNumber(control, item) {
  control.items = control.items.filter((choice) => choice.value !== item.value);
  control.value = "";
}

/** Passes each number picked in the tracked-number sp-select to `onPick`, then drops it; returns the listener's remover. */
export function listenForTrackedNumberPicks(onPick) {
  function handleTrackedNumberChange(event) {
    const item = pickedTrackedNumber(event.target);

    if (!item) {
      return;
    }

    onPick(item);
    dropTrackedNumber(event.target, item);
  }

  document.addEventListener("change", handleTrackedNumberChange);

  return function stopListening() {
    document.removeEventListener("change", handleTrackedNumberChange);
  };
}

/** Selects the workflow `value` names in a tracked number's workflow sp-select, or its first enabled choice. */
export async function selectWorkflow(control, value) {
  if (!(await settleMount(control))) {
    return;
  }

  control.value = selectValue(control.items, value);
}

function workflowSelect(fieldset) {
  return fieldset?.querySelector(".tracked-number-workflow-input");
}

/**
 * Updates or adds the number's fieldset and lists or unlists the number in the tracked-number sp-select. A number
 * select that fails to mount leaves its list alone; the fieldset is still updated.
 */
export async function updateTrackedNumberForm(numberData, addFieldset) {
  const fieldsetId = `tracked_number_${numberData.fieldset_id}`;
  const fieldset = document.getElementById(fieldsetId);
  const numberControl = await settleMount(document.getElementById(TRACKED_NUMBER_SELECT_ID));
  const numberValue = String(numberData.original_number_id);
  const items = numberControl?.items ?? [];
  const listed = items.some((item) => item.value === numberValue);

  if (fieldset) {
    for (const input of fieldset.querySelectorAll(".tracked-number-enabled-input")) {
      input.checked = numberData.enabled;
    }

    await selectWorkflow(workflowSelect(fieldset), numberData.workflow_id);
  } else if (numberData.enabled) {
    addFieldset(numberData);
    await selectWorkflow(workflowSelect(document.getElementById(fieldsetId)), numberData.workflow_id);

    if (numberControl) {
      numberControl.items = items.filter((item) => item.value !== numberValue);
    }
  } else if (numberControl && !listed) {
    numberControl.items = items.concat({
      title: numberData.original_number,
      value: numberValue,
      dataset: {},
    });
  }
}
